<template>
  <FormLabel :required="required" :text="text" :error="(!disabled)? (forceError || error): ''" class="aoformlabel_textarea">
    <textarea class="aoformfield" :placeholder="placeholder" ref="input" :readonly="disabled || $store.getters.loading"
           type="text" 
           :name="name"
           v-maska 
           :maxlength="maxlength"
           :data-maska="mask"
           @blur="filledCheck"
           autocomplete="off"
           @keydown.down.stop.prevent="$refs.droplist.focus()"
           v-model="val"/>
    <DropList v-if="options"
      :options="options"
      :search="val"
      v-model="val"
      ref="droplist"
      @input="dropinput"
      />
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import DropList from '@/components/DropList.vue'
import FormField from '@/mixins/FormField.vue'
import blur from '@/mixins/blur'
import { vMaska } from 'maska'
export default {
  components: { FormLabel, DropList },
  mixins: [FormField, blur],
  directives: { maska: vMaska },
  props: {
    required: { type: Boolean, default: false },
    mask: {type: String},
    maxlength: { default: null },
    name: {type: String, required: true},
    modelValue: {type: String, default: ''},
    text: {type: String, required: true},
    options: {type: Array},
    disabled: {type: Boolean, default: false},
    selectonly: {type: Boolean, default: false},
    placeholder: {type: String},
    blurcondition: undefined,
    validation: {type: Function, default: ()=>''},
    forceError: {type: String, default: ''},
    filled: {type: Function, default: (v)=>v?true:false}
  },
  data: ()=>({
    error: '',
    selected: ''
  }),
  computed:{
    val: {
      get () { return this.modelValue },
      set (value) { this.$emit('update:modelValue', value) },
    },
  },
  watch: {
    modelValue(newVal){
      this.checkValue(newVal)
      //if (newVal && !this.error) 
        //this.$store.dispatch('callAction', this.name)
    }
  },
  methods:{
    dropinput(val){
      if (this.blurcondition === undefined) 
        return this.blur()
      else 
        this.$nextTick(()=>this.blurcondition?this.blur():this.$refs.input.focus())
      this.selected = val
    },
    checkValue(value){
      this.error = this.validation(value) || ((this.selectonly && this.selected !== value)?'Выберите значение из списка':'')
    },
    filledCheck(){
      if (this.modelValue == '') return this.error = ""
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
      }
    }
  }
}
</script>

<style lang="sass">

</style>